import React, { useState, useEffect } from 'react';
import bookingService from '../../../../../../services/booking.service';
import { useEyeconxStore } from '../../../../../../store/eyeconxStore';
import { ClinicInfoPanel } from '../../info/clinicInfoParts';
import ClinicSettingsEmpty from '../../subparts/ClinicSettingsEmpty';
import ClinicSettingsListSkeleton from '../../subparts/ClinicSettingsListSkeleton';

const AppointmentItem = ({ item }) => (
    <div className="clinic-settings-record-item">
        <span className="clinic-settings-record-item__avatar">
            <i className="bi bi-calendar-event"></i>
        </span>
        <div className="clinic-settings-record-item__main">
            <h6 className="clinic-settings-record-item__title">{item?.apptType}</h6>
            <p className="clinic-settings-record-item__meta mb-0">
                <i className="bi bi-stopwatch me-1"></i>
                {item?.timeSlot} minutes
            </p>
        </div>
        <span className={`clinic-settings-status-pill ${item?.isActive ? 'is-open' : 'is-closed'}`}>
            {item?.isActive ? 'Active' : 'Inactive'}
        </span>
    </div>
);

const AppointmentTypeCard = ({ onManage }) => {
    const clinicId = useEyeconxStore((state) => state.user.clinicId);
    const [appointmentTypes, setAppointmentTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getAppointmentTypes();
    }, [clinicId]);

    const getAppointmentTypes = async () => {
        setIsLoading(true);
        try {
            const res = await bookingService.getAllAppointmentTypes(clinicId);
            setAppointmentTypes(res.data || []);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
            <ClinicInfoPanel title="Appointment Types" icon="bi-calendar-check">
                <ClinicSettingsListSkeleton rows={3} />
            </ClinicInfoPanel>
        );
    }

    return (
        <ClinicInfoPanel
            title="Appointment Types"
            icon="bi-calendar-check"
            actions={(
                <button type="button" className="btn btn-sm btn-light-primary rounded-pill" onClick={onManage}>
                    <i className="bi bi-sliders me-1"></i>
                    Manage
                </button>
            )}
        >

            {appointmentTypes.length === 0 ? (
                <ClinicSettingsEmpty
                    icon="bi-calendar-x"
                    title="No appointment types"
                    description="Configure appointment types for online booking."
                    actionLabel="Manage Types"
                    onAction={onManage}
                />
            ) : (
                <div className="clinic-settings-record-list">
                    {appointmentTypes.map((apptType, index) => (
                        <AppointmentItem key={apptType.id || index} item={apptType} />
                    ))}
                </div>
            )}
        </ClinicInfoPanel>
    );
};

export default AppointmentTypeCard;
